<template>
  <div class="grid">
    <template v-for="option in options" :key="option.label">
      <div class="mr-2">
        <AtomsRadioInput :aria-label="option.value" :disabled="option.disabled" :option="option" :with-border="false" v-bind="$attrs" />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { Options } from '@/models/selectBox';

interface Props {
  options: Options;
}

withDefaults(defineProps<Props>(), {});
</script>
